import MockAdapter from 'axios-mock-adapter';

export const TEST_USERS = [
  {
    context: 'Applicants',
    role: 'applicant',
    id: '1',
    username: 'maya',
    firstName: 'Maya',
    lastName: 'Smith'
  },
  {
    context: 'Employer',
    role: 'manager',
    id: '2',
    username: 'jane',
    firstName: 'Jane',
    lastName: 'Manager'
  }
];

const resources = [
  {id: 1, title: 'React for beginners'},
  {id: 2, title: 'CSS for beginners'},
];

const initMock = (mock) => {
  mock.onGet('/keepAlive').reply(200);

  mock.onGet('/users/:username').reply(config => {
    console.log('config', config);
    const user = TEST_USERS.find(u => u.username === 'maya');
    return [200, user];
  });

  mock.onGet('/resources').reply(200, resources);

  mock.onPost('/resources').reply(config => {
    const payload = JSON.parse(config.data);
    resources.push({ id: resources.length+1, ...payload });
    console.log('resources agyer add', payload, resources);
    return [200, resources]
  });
};

const wrapWithMock = (axios) => {
  const mock = new MockAdapter(axios);
  initMock(mock);
  return mock;
};

export default wrapWithMock;
